export enum HubTypeEnum {
  None = 0,
  Motorsport,
  AutoWorld,
  Motorbikes,
  LegacyMotors,
  HeavyWheels,
  Roadtrip,
}
